import { TranslateResult } from 'vue-i18n';
import { i18n } from './../../../i18n';
import { BuyType } from '@tt4b/ttam-enums';

export type buyingTypeOptionsType = {
  value: number;
  labelKey: string | TranslateResult;
};

export const genBuyingTypeOptions: () => buyingTypeOptionsType[] = () => [
  {
    value: BuyType.PURCHASE,
    labelKey: i18n.t('adgroup_purchase'),
  },
  {
    value: BuyType.TRADE,
    labelKey: i18n.t('adgroup_trade'),
  },
  {
    value: BuyType.COMPLIMENTARY,
    labelKey: i18n.t('adgroup_complimentary'),
  },
  {
    value: BuyType.PROMOTION,
    labelKey: i18n.t('adgroup_promotion'),
  },
  {
    value: BuyType.MAKE_GOOD,
    labelKey: i18n.t('adgroup_make_good'),
  },
];
